

const selector = "[data-siv]"
let options = {
  classElement: "siv-element",
  singleShotMode: false ,
  offset: 0.01,
  offsetTop: 0.01,
}

const update = (e) => {
  const nodeList = [...document.querySelectorAll(selector)]
  if (!nodeList || !nodeList.length) {
    return
  }  
  nodeList.forEach( (el, index) => {
    if (el && el.classList) {
      el.classList.add(options.classElement)
      const classIn = el.dataset.siv
      const classOut = el.dataset.sivOut    
      if (isElementInViewport(el)) {
        el.classList.add(classIn)
      } else if (!options.singleShotMode) {
        el.classList.remove(classIn)      
      } 
      if (classOut) {
        if (isElementOutOfViewport(el)) {
          el.classList.add(classOut)
        } else {
          el.classList.remove(classOut)
        }
      }
    }
  })
}

const isElementInViewport = (el) => {
  const rect = el.getBoundingClientRect()
  const top = rect.top + window.innerHeight * options.offset
  return (top <= (window.innerHeight || document.documentElement.clientHeight)) && ( rect.left <= (window.innerWidth || document.documentElement.clientWidth))
}

const isElementOutOfViewport = (el) => {
  const rect = el.getBoundingClientRect()
  const bottom = rect.bottom - window.innerHeight * options.offsetTop
  return bottom < 0
}


export const initSiv = ( params = {} ) => {
  for ( let param in params ) {
    if ( options.hasOwnProperty(param) ) {
      options[param] = params[param]
    }
  }
  document.addEventListener("scroll", update)
  document.addEventListener("resize", update)
  document.addEventListener("DOMContentLoaded", update)
  document.addEventListener("touchmove", update)
  update()
}

export const destroySiv = () => {
  document.removeEventListener("scroll", update)
  document.removeEventListener("resize", update)
  document.removeEventListener("DOMContentLoaded", update)
  document.removeEventListener("touchmove", update)
}

export const updateSiv = () => {
  update() 
}
